<template>
  <div class="lufthansa-temporary-banner w-full py-4 px-4 block md:flex flex-row text-white items-center">
    <div class="flex flex-col sm:flex-row md:contents items-left md:items-center mb-2 md:mb-0">
      <div class="block sm:contents">
        <img
          class="pr-6 mr-1"
          :src="logo"
          height="100%"
        />
      </div>
      <h4 class="my-0 pr-6 mr-1 mt-1">
        &num;{{ hashTag }}
      </h4>
    </div>
    <small>{{ $t(text) }} {{ ' ' }}<a
      :href="`https://${link}`"
      target="_blank"
    >{{ link }}</a>
    </small>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logo: '/banners/lufthansa.png',
      hashTag: 'MakeChangeFly',
      text: 'lufthansaBannerReadMoreAt',
      link: 'www.lufthansagroup.com/en/responsibility/climate-environment',
    }
  },
}
</script>

<style lang="scss">
.lufthansa-temporary-banner {
  background: theme('colors.lufthansa-brand');

  img {
    height: 28px;
  }

  a {
    color: theme('colors.orange.DEFAULT');
  }
}
</style>
